import { FormProvider } from 'react-hook-form';
import { useEditUserForm } from './hooks/useEditUserForm';
import { convertToPresentationProps } from './logics/convertToPresentationProps';
import { EditUserFormPresentation } from './presentations';

type Props = {
  userId: number;
};

/**
 * 利用者編集フォーム Container コンポーネント
 * 利用者情報の取得・更新を管理し、編集フォームを表示する
 */
export const EditUserForm: React.FC<Props> = ({ userId }) => {
  const {
    state: { userData, methods, branchOptions, isMutating },
    actions: { handleSubmit, handleCancel },
  } = useEditUserForm({ userId });

  const { fullName, isBillableFromEditable } = convertToPresentationProps({ data: userData });

  return (
    <FormProvider {...methods}>
      <EditUserFormPresentation
        fullName={fullName}
        branchOptions={branchOptions}
        isMutating={isMutating}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        isBillableFromEditable={isBillableFromEditable}
      />
    </FormProvider>
  );
};
